import CompanySalesEmailDialog from "./company-sales-email-dialog.container";

export default CompanySalesEmailDialog;
